import { render } from "./RolesScreen.vue?vue&type=template&id=3b33e452&scoped=true"
import script from "./RolesScreen.vue?vue&type=script&lang=js"
export * from "./RolesScreen.vue?vue&type=script&lang=js"

import "./RolesScreen.vue?vue&type=style&index=0&id=3b33e452&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b33e452"]])

export default __exports__